<mat-card appearance="outlined" >
    <div class="spinner-div" *ngIf="isLoading; else isNotLoading"><mat-spinner mode="indeterminate" [diameter]="50" color="primary"></mat-spinner></div>
    <ng-template #isNotLoading>
        <div *ngIf="searchResult && searchResult.length !== 0; else noResultBlock" class="table-div">
            <table mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="row">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td  mat-cell *matCellDef="let row">
                        <div class="info-div">
                            <a (click)="loadEditor(row.foundFile)">{{stripHtml(row.foundFile.name)}}</a>
                            <div class="html-div" innerHTML="{{ stripHtml(row.foundStrings) | highlight : wordSearched}}" ></div>
                        </div>
                    </td>
                </ng-container>
                <mat-row *matRowDef="let row; columns: tableColumns" class="html-mat-row"></mat-row>
            </table>
        </div>
    </ng-template>
    <ng-template #noResultBlock>
        <div><mat-label class="no-result-label">{{'components.wiki.searchResult.noResult.fullLabel' | translate}}</mat-label></div>
    </ng-template>
    <mat-paginator [showFirstLastButtons]="true" [pageSizeOptions]="[10,20,50]"></mat-paginator>
</mat-card>